/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CreasDettaglioPraticaCtrl = function (
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    $uibModal,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    userSrvc,
    dettPraticaSrvc,
    modelFctr,
    ricercaClienteSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$uibModal = $uibModal;
    this.messaggiFctr = messaggiFctr;
    this.userSrvc = userSrvc;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.ricercaClienteSrvc = ricercaClienteSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    // Variabile di controllo per la verifica della selezione di un cliente
    this.noCustomerError = false;
    this.errorFromService = false;

    // Dati Pratica
    this.datiCliente = {};
    this.affidamenti = [];

    // Spinner
    this.spinner = this.dettPraticaSrvc.spinner;

    // Configurazione Tab principali
    // La configurazione "operationsVisibility" permette di impostare se un
    // pulsante è visibile per un determinato step
    this.TAB_LIST_MACRO = [];

    // Configurazioni sotto-step
    this.TAB_LIST_MICRO = {
      STEP2: [],
      STEP3: [],
      STEP6: [],
    };

    // Tab attualmente attive
    this.currentTabMacro = {};
    this.currentTabMicro = {};

    var self = this;

    /**
     * @ngdoc method
     * @name generaTabs
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Genera le tab necessarie al processo sulla base del cliente
     *              e della pratica ricevuti
     */
    this.dettPraticaSrvc.generaTabs = function () {
      debugger;
      var isAnagraficaCerved = self.dettPraticaSrvc.isClienteCerved();
      var statoAffidamento = self.dettPraticaSrvc.affidamento.stato;

      // Svuoto le tab
      self.TAB_LIST_MACRO = [];
      self.TAB_LIST_MICRO.STEP2 = [];
      self.TAB_LIST_MICRO.STEP3 = [];
      self.TAB_LIST_MICRO.STEP6 = [];

      // Step principali
      self.TAB_LIST_MACRO.push({
        index: 0,
        title: $scope.msg('label.dettagliopratica.step1.titolotab'),
        url: 'statoAffidamento.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: false,
          prev: false,
          next: false,
          complete: false,
        },
      });

      self.TAB_LIST_MACRO.push({
        index: 1,
        title: $scope.msg('label.dettagliopratica.step2.titolotab'),
        url: 'richiestaFido.tmpl.html',
      });

      self.TAB_LIST_MACRO.push({
        index: 2,
        title: $scope.msg('label.dettagliopratica.step3.titolotab'),
        url: 'valutazionePratica.tmpl.html',
      });

      self.TAB_LIST_MACRO.push({
        index: 3,
        title: $scope.msg('label.dettagliopratica.step4.titolotab'),
        url: 'sceltaConto.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: true,
          prev: true,
          next: true,
          complete: false,
        },
      });

      self.TAB_LIST_MACRO.push({
        index: 4,
        title: $scope.msg('label.dettagliopratica.step5.titolotab'),
        url: 'affidamentoDocumenti.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: true,
          prev: true,
          next: true,
          complete: false,
        },
      });

      self.TAB_LIST_MACRO.push({
        index: 5,
        title: $scope.msg('label.dettagliopratica.step6.titolotab'),
        url: 'praticaPagamento.tmpl.html',
      });

      // Sotto-step - Step 2
      self.TAB_LIST_MICRO.STEP2.push({
        index: 0,
        title: $scope.msg('label.dettagliopratica.step2.sub1.titolotab'),
        url: 'datiAffidamento.tmpl.html',
        operationsVisibility: {
          cancel: true,
          save: true,
          prev: false,
          next: true,
          complete: false,
        },
      });

      self.TAB_LIST_MICRO.STEP2.push({
        index: 1,
        title: $scope.msg('label.dettagliopratica.step2.sub2.titolotab'),
        url: 'gestioneFirmatari.tmpl.html',
        operationsVisibility: {
          cancel: true,
          save: false,
          prev: true,
          next: true,
          complete: false,
        },
      });

      // Questo step non viene utilizzato
      self.TAB_LIST_MICRO.STEP2.push({
        index: 2,
        title: $scope.msg('label.dettagliopratica.step2.sub3.titolotab'),
        url: 'gestioneFirmatari.tmpl.html',
        operationsVisibility: {
          cancel: true,
          save: false,
          prev: true,
          next: true,
          complete: false,
        },
      });

      // Sotto-step - Step 3
      self.TAB_LIST_MICRO.STEP3.push({
        index: 0,
        title: $scope.msg('label.dettagliopratica.step3.sub1.titolotab'),
        url: 'valutazioneCerved.tmpl.html',
        operationsVisibility: {
          cancel: true,
          save: false,
          prev: true,
          next: true,
          complete: false,
        },
      });

      if (isAnagraficaCerved === true) {
        self.TAB_LIST_MICRO.STEP3.push({
          index: 1,
          title: $scope.msg('label.dettagliopratica.step3.sub2.titolotab'),
          url: 'integrazioneAnagrafica.tmpl.html',
          operationsVisibility: {
            cancel: false,
            save: false,
            prev: true,
            next: true,
            complete: false,
          },
        });
      }

      // Sotto-step - Step 6
      self.TAB_LIST_MICRO.STEP6.push({
        index: 0,
        title: $scope.msg('label.dettagliopratica.step6.sub1.titolotab'),
        url: 'sceltaConvenzione.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: true,
          prev: false,
          next: true,
          complete: false,
        },
      });

      self.TAB_LIST_MICRO.STEP6.push({
        index: 1,
        title: $scope.msg('label.dettagliopratica.step6.sub2.titolotab'),
        url: 'sceltaPolizze.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: true,
          prev: true,
          next: true,
          complete: false,
        },
      });

      self.TAB_LIST_MICRO.STEP6.push({
        index: 2,
        title: $scope.msg('label.dettagliopratica.step6.sub3.titolotab'),
        url: 'riepilogoPolizze.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: true,
          prev: true,
          next: true,
          complete: false,
        },
      });

      self.TAB_LIST_MICRO.STEP6.push({
        index: 3,
        title: $scope.msg('label.dettagliopratica.step6.sub4.titolotab'),
        url: 'pagamentoGestioneDocumenti.tmpl.html',
        operationsVisibility: {
          cancel: false,
          save: false,
          prev: false,
          next: false,
          complete: true,
        },
      });

      // Eseguo il refresh delle liste
      self.TAB_LIST_MACRO = self.TAB_LIST_MACRO.concat([]);
      self.TAB_LIST_MICRO.STEP2 = self.TAB_LIST_MICRO.STEP2.concat([]);
      self.TAB_LIST_MICRO.STEP3 = self.TAB_LIST_MICRO.STEP3.concat([]);
      self.TAB_LIST_MICRO.STEP6 = self.TAB_LIST_MICRO.STEP6.concat([]);

      // Imposto i tab attivi
      var tabMacroIndex = CONSTANTS.STATI_PRATICA.indexOf(
        self.dettPraticaSrvc.datiPratica.stato
      );
      tabMacroIndex = tabMacroIndex < 0 ? 0 : tabMacroIndex;

      var microStep = self.dettPraticaSrvc.datiPratica.step;
      microStep = microStep ? microStep - 1 : 0;

      // Step 2 - Forzatura per gestire il Widget FEA/Documenti
      if (tabMacroIndex === 1 && microStep >= 2 && microStep <= 6) {
        microStep = 1;
      }
      // Step 2 - Forzatura per gestire il Widget FEA/Documenti
      if (tabMacroIndex === 5 && microStep >= 4) {
        microStep = 3;
      }
      // Step 3 - Forzatura per convertire INTEGRAZIONE in VALUTAZIONE
      if (tabMacroIndex === 6) {
        tabMacroIndex = 2;
        microStep = 1;
      }

      self.currentTabMacro = self.TAB_LIST_MACRO[tabMacroIndex];
      self.currentTabMicro = {
        STEP2: self.TAB_LIST_MICRO.STEP2[microStep],
        STEP3: self.TAB_LIST_MICRO.STEP3[microStep],
        STEP6: self.TAB_LIST_MICRO.STEP6[microStep],
      };
    };

    /**
     * @ngdoc method
     * @name macroTabClicked
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Gestisce il click sulle macro tab
     * @param {Object} tab: l'oggetto tab selezionato
     */
    this.macroTabClicked = function (tab) {
      if (self.dettPraticaSrvc.isPraticaNavigabile() !== true) {
        return;
      }

      // Non posso selezionare la tab Pagamento
      if (tab.index === 5) {
        return;
      }

      self.currentTabMacro = tab;
      self.currentTabMicro = {
        STEP2: self.TAB_LIST_MICRO.STEP2[0],
        STEP3: self.TAB_LIST_MICRO.STEP3[0],
        STEP6: self.TAB_LIST_MICRO.STEP6[0],
      };
    };

    /**
     * @ngdoc method
     * @name apriMicroTab
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Apre la micro tab indicata per lo step passato
     * @param {Object} tab: l'oggetto tab selezionato
     * @param {number} macroTabIndex: l'indice della macro-tab da gestire (in base 1)
     */
    this.dettPraticaSrvc.apriMicroTab = function (tab, macroTabIndex) {
      if (self.currentTabMicro['STEP' + macroTabIndex]) {
        self.currentTabMicro['STEP' + macroTabIndex] = tab;
      }
    };

    /**
     * @ngdoc method
     * @name apriRicercaCliente
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Apre la pagina di ricerca cliente
     */
    this.apriRicercaCliente = function () {
      self.$state.go('creas-ricerca-cliente');
    };

    /**
     * @ngdoc method
     * @name isCancelVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante di annullamento pratica è visibile
     *              per lo step attivo
     */
    this.isCancelVisible = function () {
      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
      ) {
        return false;
      }

      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
      ) {
        return false;
      }

      if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
        return false;
      }

      if (
        self.dettPraticaSrvc.isCancelVisible &&
        typeof self.dettPraticaSrvc.isCancelVisible === 'function'
      ) {
        return self.dettPraticaSrvc.isCancelVisible();
      }

      var stepNumber = self.currentTabMacro.index + 1;

      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
      // invece che del macro-step
      if (
        self.currentTabMicro['STEP' + stepNumber] &&
        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
      ) {
        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
          .cancel;
      }

      if (!self.currentTabMacro.operationsVisibility) {
        return false;
      }

      return self.currentTabMacro.operationsVisibility.cancel;
    };

    /**
     * @ngdoc method
     * @name isCancelEnabled
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante di annullamento pratica è
     *              disabilitato per lo step attivo
     */
    this.isCancelEnabled = function () {
      if (
        self.dettPraticaSrvc.isCancelEnabled &&
        typeof self.dettPraticaSrvc.isCancelEnabled === 'function'
      ) {
        return self.dettPraticaSrvc.isCancelEnabled();
      }

      return false;
    };

    /**
     * @ngdoc method
     * @name isCancelFinanziamentoVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante di annullamento finanziamento è visibile
     *              per lo step attivo
     */
    this.isCancelFinanziamentoVisible = function () {
      if (
        self.dettPraticaSrvc.isCancelFinanziamentoVisible &&
        typeof self.dettPraticaSrvc.isCancelFinanziamentoVisible === 'function'
      ) {
        return self.dettPraticaSrvc.isCancelFinanziamentoVisible();
      }
      return false;
    };

    /**
     * @ngdoc method
     * @name isCancelFinanziamentoEnabled
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante di annullamento finanziamento è
     *              disabilitato per lo step attivo
     */
    this.isCancelFinanziamentoEnabled = function () {
      if (
        self.dettPraticaSrvc.isCancelFinanziamentoEnabled &&
        typeof self.dettPraticaSrvc.isCancelFinanziamentoEnabled === 'function'
      ) {
        return self.dettPraticaSrvc.isCancelFinanziamentoEnabled();
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name isTornaASchedaClienteVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante Torna a scheda cliente è visibile
     */
    this.isTornaASchedaClienteVisible = function () {
      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
      ) {
        return true;
      }

      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
      ) {
        return true;
      }

      if (self.dettPraticaSrvc.isPraticaNavigabile() === true) {
        return true;
      }

      return false;
    };

    /**
     * @ngdoc method
     * @name tornaASchedaCliente
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Apre la pagina della scheda cliente
     */
    this.tornaASchedaCliente = function () {
      self.$state.go('schedaCliente', { ndg: self.datiCliente.ndg });
    };

    /**
     * @ngdoc method
     * @name isSaveVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante di salvataggio pratica è visibile
     *              per lo step attivo
     */
    this.isSaveVisible = function () {
      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
      ) {
        return false;
      }

      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
      ) {
        return false;
      }

      var stepNumber = self.currentTabMacro.index + 1;

      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
      // invece che del macro-step
      if (
        self.currentTabMicro['STEP' + stepNumber] &&
        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
      ) {
        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
          .save;
      }

      if (!self.currentTabMacro.operationsVisibility) {
        return false;
      }

      return self.currentTabMacro.operationsVisibility.save;
    };

    /**
     * @ngdoc method
     * @name isSaveEnabled
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante di salvataggio pratica è
     *              disabilitato per lo step attivo
     */
    this.isSaveEnabled = function () {
      if (
        self.dettPraticaSrvc.isSaveEnabled &&
        typeof self.dettPraticaSrvc.isSaveEnabled === 'function'
      ) {
        return self.dettPraticaSrvc.isSaveEnabled();
      }

      return false;
    };

    /**
     * @ngdoc method
     * @name isPrevVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante "Indietro" è visibile per lo step
     *              attivo
     */
    this.isPrevVisible = function () {
      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
      ) {
        return false;
      }

      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
      ) {
        return false;
      }

      var stepNumber = self.currentTabMacro.index + 1;

      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
      // invece che del macro-step
      if (
        self.currentTabMicro['STEP' + stepNumber] &&
        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
      ) {
        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
          .prev;
      }

      if (!self.currentTabMacro.operationsVisibility) {
        return false;
      }

      return self.currentTabMacro.operationsVisibility.prev;
    };

    /**
     * @ngdoc method
     * @name isPrevEnabled
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante 'Indietro' della pratica è
     *              disabilitato per lo step attivo
     */
    this.isPrevEnabled = function () {
      if (
        self.dettPraticaSrvc.isPrevEnabled &&
        typeof self.dettPraticaSrvc.isPrevEnabled === 'function'
      ) {
        return self.dettPraticaSrvc.isPrevEnabled();
      }

      return false;
    };

    /**
     * @ngdoc method
     * @name isNextVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante "Prosegui" è visibile per lo step
     *              attivo
     */
    this.isNextVisible = function () {
      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
      ) {
        return false;
      }

      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
      ) {
        return false;
      }

      var stepNumber = self.currentTabMacro.index + 1;

      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
      // invece che del macro-step
      if (
        self.currentTabMicro['STEP' + stepNumber] &&
        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
      ) {
        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
          .next;
      }

      if (!self.currentTabMacro.operationsVisibility) {
        return false;
      }

      return self.currentTabMacro.operationsVisibility.next;
    };

    /**
     * @ngdoc method
     * @name isNextEnabled
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante 'Prosegui' della pratica è
     *              disabilitato per lo step attivo
     */
    this.isNextEnabled = function () {
      if (
        self.dettPraticaSrvc.isNextEnabled &&
        typeof self.dettPraticaSrvc.isNextEnabled === 'function'
      ) {
        return self.dettPraticaSrvc.isNextEnabled();
      }

      return false;
    };

    /**
     * @ngdoc method
     * @name isCompleteVisible
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante "Completa" è visibile per lo step
     *              attivo
     */
    this.isCompleteVisible = function () {
      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'ANNULLATA'
      ) {
        return false;
      }

      if (
        self.dettPraticaSrvc.datiPratica &&
        self.dettPraticaSrvc.datiPratica.stato === 'RIFIUTATA'
      ) {
        return false;
      }

      var stepNumber = self.currentTabMacro.index + 1;

      // Se ho dei sotto-step, verifico le proprietà del sotto-step attivo
      // invece che del macro-step
      if (
        self.currentTabMicro['STEP' + stepNumber] &&
        self.currentTabMicro['STEP' + stepNumber].operationsVisibility
      ) {
        return self.currentTabMicro['STEP' + stepNumber].operationsVisibility
          .complete;
      }

      if (!self.currentTabMacro.operationsVisibility) {
        return false;
      }

      return self.currentTabMacro.operationsVisibility.complete;
    };

    /**
     * @ngdoc method
     * @name isCompleteEnabled
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Verifica se il pulsante 'Prosegui' della pratica è
     *              disabilitato per lo step attivo
     */
    this.isCompleteEnabled = function () {
      if (
        self.dettPraticaSrvc.isCompleteEnabled &&
        typeof self.dettPraticaSrvc.isCompleteEnabled === 'function'
      ) {
        return self.dettPraticaSrvc.isCompleteEnabled();
      }

      return false;
    };

    /**
     * @ngdoc method
     * @name prevStep
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Permette all'utente di tornare indietro nei passaggi della
     *              pratica
     */
    this.prevStep = function () {
      self.spinner.pratica = true;
      $q.all({
        prevStep: self.dettPraticaSrvc.promiseCambiaStep('/indietroStep'),
      })
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response.prevStep)) {
              return;
            }

            self.dettPraticaSrvc.datiPratica = response.prevStep.data.result;
            dettPraticaSrvc.generaTabs();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.prevStep);
          }
        )
        .finally(function () {
          self.spinner.pratica = false;
        });
    };

    /**
     * @ngdoc method
     * @name nextStep
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Esegue le verifiche necessarie e fa avanzare l'utente al
     *              passaggio successivo della pratica
     */
    this.nextStep = function () {
      if (
        self.dettPraticaSrvc.nextStep &&
        typeof self.dettPraticaSrvc.nextStep === 'function'
      ) {
        return self.dettPraticaSrvc.nextStep();
      }
      return;
    };

    /**
     * @ngdoc method
     * @name setTabListIndex
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Imposta l'indice del tab in base a quanto riportato nella
     *              pratica
     */

    /**
     * @ngdoc method
     * @name completaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Esegue le operazioni di chiusura e completamento della
     *              pratica attiva
     */
    this.completaPratica = function () {
      if (
        self.dettPraticaSrvc.completed &&
        typeof self.dettPraticaSrvc.completed === 'function'
      ) {
        return self.dettPraticaSrvc.completed();
      }
      return;
    };

    /**
     * @ngdoc method
     * @name openStepFinanziamentoPolizze
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Apre lo step 6, Pagamento - Sottostep 1, Scelta convenzione
     */
    this.openStepFinanziamentoPolizze = function () {
      self.openDefinedTab(5, 0);
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacro
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacro = function (currentTabIndex) {
      // Pratica non navigabile
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-pass';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current';
      }

      return 'progress-next';
    };

    /**
     * @ngdoc method
     * @name getStyleTabMacroReadOnly
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Imposta lo stile di visualizzazione per gli indicatori dei macro step in modalità sola lettura
     * @param {number} currentTabIndex - L'indice della tab cui applicare lo stile
     * @return {string} - Restituisce lo stile da applicare all'indicatore del macro step
     */
    this.getStyleTabMacroReadOnly = function (currentTabIndex) {
      if (currentTabIndex < this.currentTabMacro.index) {
        return 'progress-next-read';
      }

      if (currentTabIndex === this.currentTabMacro.index) {
        return 'progress-current-read';
      }

      return 'progress-next-read';
    };

    /**
     * @ngdoc method
     * @name promiseAffidamenti
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Effettua una chiamata http per ricevere i dati degli affidamenti legati alla pratica
     * @param {number} idPratica - ID Della pratica della quale recuperare i dati
     * @return {Promise} - Ritorna una promise contenente i dati degli affidamenti legati alla pratica
     */
    this.promiseAffidamenti = function (idPratica) {
      this.spinner.pratica = true;
      return this.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PRATICHE.DETTAGLIO +
          idPratica +
          '/affidamenti',
      });
    };

    /**
     * @ngdoc method
     * @name setAffidamentoAttuale
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Imposta l'affidamento corrente in base a quelli recuperati
     *              per la pratica, basandosi sulla data apertura
     */
    this.setAffidamentoAttuale = function () {
      self.dettPraticaSrvc.affidamento = self.affidamenti;
    };

    /**
     * @ngdoc method
     * @name promiseAnnullaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Effettua una chiamata http per eseguire l'annullamento della
     *              pratica in lavorazione
     * @return {Promise} - Ritorna una promise contenente l'esito
     *         dell'annulamento pratica
     */
    this.promiseAnnullaPratica = function () {
      this.spinner.pratica = true;
      return this.$http({
        method: 'DELETE',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PRATICHE.DETTAGLIO +
          self.dettPraticaSrvc.datiPratica.idPratica,
      });
    };

    /**
     * @ngdoc method
     * @name annullaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Richiede conferma e, in caso positivo, esegue l'annullamento
     *              della pratica
     */
    this.annullaPratica = function () {
      var modalController = function ($scope, LabelSrvc, $modalInstance) {
        $scope.headerText = LabelSrvc.getLabel(
          'label.dettagliopratica.annulla.header'
        );
        $scope.bodyText = LabelSrvc.getLabel(
          'label.dettagliopratica.annulla.content'
        );
        $scope.cancelText = LabelSrvc.getLabel(
          'button.dettagliopratica.annulla.cancel'
        );
        $scope.confirmText = LabelSrvc.getLabel(
          'button.dettagliopratica.annulla.confirm'
        );

        $scope.optionSelected = function (result) {
          $modalInstance.close(result);
        };
      };

      modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];

      var modalInstance = this.$uibModal.open({
        animation: true,
        template:
          '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
        backdrop: 'static',
        size: 'lg',
        controller: modalController,
      });

      modalInstance.result.then(function (confirmResult) {
        if (confirmResult !== true) {
          return;
        }

        // Eseguo l'annullamento
        $q.all({
          annullamento: self.promiseAnnullaPratica(),
        })
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response.annullamento)) {
                return;
              }

              if (response.annullamento.data.result !== true) {
                return;
              }

              self.$state.go('creas-ricerca-pratiche');
            },
            function (reason) {
              self.messaggiFctr.processaResponse(reason.annullamento);
            }
          )
          .finally(function () {
            self.spinner.pratica = false;
          });
      });
    };

    /**
     * @ngdoc method
     * @name promiseAnnullaFinanziamento
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Effettua una chiamata http per eseguire l'annullamento del finanziamento in lavorazione
     * @return {Promise} - Ritorna una promise contenente l'esito
     *         dell'annulamento finanziamento
     */
    this.promiseAnnullaFinanziamento = function () {
      this.spinner.pratica = true;
      return this.$http({
        method: 'DELETE',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.FINANZIAMENTI +
          '/' +
          self.dettPraticaSrvc.getFinanziamentoBozza().idFinanziamentoPMI,
      });
    };

    /**
     * @ngdoc method
     * @name annullaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Richiede conferma e, in caso positivo, esegue l'annullamento
     *              della pratica
     */
    this.annullaFinanziamento = function () {
      var modalController = function ($scope, LabelSrvc, $modalInstance) {
        $scope.headerText = LabelSrvc.getLabel(
          'label.dettagliopratica.annulla.finanziamento.header'
        );
        $scope.bodyText = LabelSrvc.getLabel(
          self.dettPraticaSrvc.datiPratica.step === 4
            ? 'label.dettagliopratica.annulla.finanziamento.documenti.content'
            : 'label.dettagliopratica.annulla.finanziamento.content'
        );
        $scope.cancelText = LabelSrvc.getLabel(
          'button.dettagliopratica.annulla.cancel'
        );
        $scope.confirmText = LabelSrvc.getLabel(
          'button.dettagliopratica.annulla.finanziamento.confirm'
        );

        $scope.optionSelected = function (result) {
          $modalInstance.close(result);
        };
      };

      modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];

      var modalInstance = this.$uibModal.open({
        animation: true,
        template:
          '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
        backdrop: 'static',
        size: 'lg',
        controller: modalController,
      });

      modalInstance.result.then(function (confirmResult) {
        if (confirmResult !== true) {
          return;
        }

        // Eseguo l'annullamento
        $q.all({
          annullamento: self.promiseAnnullaFinanziamento(),
        })
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response.annullamento)) {
                return;
              }
              self.dettPraticaSrvc.isCancelFinanziamentoVisible = null;
              self.dettPraticaSrvc.isCancelFinanziamentoEnabled = null;
              self.dettPraticaSrvc.datiPratica =
                response.annullamento.data.result;
              self.dettPraticaSrvc.generaTabs();
            },
            function (reason) {
              self.messaggiFctr.processaResponse(reason.annullamento);
            }
          )
          .finally(function () {
            self.spinner.pratica = false;
          });
      });
    };

    /**
     * @ngdoc method
     * @name promiseNuovaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Effettua una chiamata http per eseguire la creazione di una
     *              nuova pratica
     * @return {Promise} - Ritorna una promise contenente l'esito della
     *         creazione della pratica
     */
    this.promiseNuovaPratica = function () {
      var nuovaPratica = modelFctr.pratica();
      // setto l'NDG
      nuovaPratica.intestatario.ndg = self.$stateParams.ndg;
      // Setto il codice prodotto CPT
      nuovaPratica.prodotto.codiceProdottoCPT = self.$stateParams.codProdotto;

      this.spinner.pratica = true;
      return this.$http({
        method: 'POST',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.PRATICHE.DETTAGLIO,
        data: nuovaPratica,
      });
    };

    /**
     * @ngdoc method
     * @name salvaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Esegue il salvataggio della pratica in lavorazione
     */
    this.salvaPratica = function () {
      if (
        self.dettPraticaSrvc.salva &&
        typeof self.dettPraticaSrvc.salva === 'function'
      ) {
        return self.dettPraticaSrvc.salva();
      }
      return;
    };

    this.promiseRicercaClientiBanca = function (idPratica) {
      var queryParamsObj = {
        idPratica: idPratica,
        firmatario: false,
      };

      var url = CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.DETTAGLIO_CERCA;

      return this.$http({
        method: 'GET',
        url: url,
        params: queryParamsObj,
      });
    };

    /**
     * @ngdoc method
     * @name inizializzaPraticaEsistente
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Recupera i dati della pratica indicata come parametro
     * @param {number}
     *            idPratica - Identificativo della pratica da recuperare
     */
    this.inizializzaPraticaEsistente = function (idPratica) {
      self.spinner.pratica = true;

      $q.all({
        datiPratica: self.dettPraticaSrvc.promiseDatiPratica(idPratica),
        cliente: self.promiseRicercaClientiBanca(idPratica),
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(response.datiPratica) ||
              self.messaggiFctr.processaResponse(response.cliente)
            ) {
              self.dettPraticaSrvc.datiPratica = {};
              self.dettPraticaSrvc.datiCliente = null;
              self.affidamenti = [];
              return;
            }

            self.dettPraticaSrvc.reset();

            self.dettPraticaSrvc.datiPratica = response.datiPratica.data.result;
            self.dettPraticaSrvc.finanziamento =
              self.dettPraticaSrvc.getFinanziamentoBozza();

            self.datiCliente = self.dettPraticaSrvc.datiCliente =
              response.cliente.data.result;
            self.affidamenti =
              response.datiPratica.data.result.fidoNonOperativo;

            self.setAffidamentoAttuale();
            dettPraticaSrvc.generaTabs();
            // if (
            // self.dettPraticaSrvc.datiPratica.step &&
            // self.dettPraticaSrvc.datiPratica.step > 1
            // ) {
            // self.openDefinedTab(self.dettPraticaSrvc.datiPratica.step);
            // }
            self.verificaStatoFido();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.datiPratica);
            self.messaggiFctr.processaResponse(reason.affidamenti);
            self.dettPraticaSrvc.datiPratica = {};
            self.affidamenti = [];
          }
        )
        .finally(function () {
          self.spinner.pratica = false;
        });
    };

    this.verificaStatoFido = function () {
      if (self.dettPraticaSrvc.datiPratica.stato === 'GESTIONEPOLIZZE') {
        var msg = null;
        //TODO Spostare in messages.properties
        if (
          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.stato === 'BLOCCATO'
        ) {
          msg =
            "Attenzione, il fido è bloccato. E' necessario annullare l'utilizzo in corso. Confermi?";
        } else if (
          self.dettPraticaSrvc.datiPratica.fidoNonOperativo.stato ===
          'DA_RINNOVARE'
        ) {
          var date = new Date(
            self.dettPraticaSrvc.datiPratica.fidoNonOperativo.dataFineValidita
          );
          msg =
            'Attenzione, il fido è scaduto in data ' +
            date.getDate() +
            '/' +
            (date.getMonth() + 1) +
            '/' +
            date.getFullYear() +
            ". E' necessario annullare l'utilizzo in corso. Confermi?";
        }
        if (msg) {
          // Richiedo conferma prima di proseguire con l'avanzamento di step
          var modalController = function ($scope, LabelSrvc, $modalInstance) {
            $scope.headerText = LabelSrvc.getLabel('label.alertFido.header');
            $scope.bodyText = msg;
            $scope.cancelText = LabelSrvc.getLabel('label.alertFido.annulla');
            $scope.confirmText = LabelSrvc.getLabel('label.alertFido.conferma');

            $scope.optionSelected = function (result) {
              $modalInstance.close(result);
            };
          };

          modalController.$inject = ['$scope', 'LabelSrvc', '$modalInstance'];

          var modalInstance = self.$uibModal.open({
            animation: true,
            template:
              '<creas-confirm-modal header-text="headerText" body-text="bodyText" cancel-text="cancelText" confirm-text="confirmText" option-selected="optionSelected(result)"></creas-confirm-modal>',
            backdrop: 'static',
            size: 'lg',
            controller: modalController,
          });

          modalInstance.result.then(function (confirmResult) {
            if (confirmResult !== true) {
              return;
            }
            // Eseguo l'annullamento
            $q.all({
              annullamento: self.promiseAnnullaFinanziamento(),
            })
              .then(
                function (response) {
                  if (
                    self.messaggiFctr.processaResponse(response.annullamento)
                  ) {
                    return;
                  }
                  self.dettPraticaSrvc.isCancelFinanziamentoVisible = null;
                  self.dettPraticaSrvc.isCancelFinanziamentoEnabled = null;
                  self.dettPraticaSrvc.datiPratica =
                    response.annullamento.data.result;
                  self.dettPraticaSrvc.generaTabs();
                },
                function (reason) {
                  self.messaggiFctr.processaResponse(reason.annullamento);
                }
              )
              .finally(function () {
                self.spinner.pratica = false;
              });
          });
        }
      }
    };
    /**
     * @ngdoc method
     * @name inizializzaNuovaPratica
     * @methodOf cbl.insuranceloanpmi.mf.directive:creasDettaglioPratica
     * @description Recupera i dati necessari e genera la nuova pratica da
     *              lavorare
     */
    this.inizializzaNuovaPratica = function () {
      self.datiCliente = self.dettPraticaSrvc.getDatiCliente();

      if (!self.$stateParams.ndg || self.$stateParams.ndg === '') {
        self.noCustomerError = true;
        return;
      }

      self.spinner.pratica = true;

      // Genero la nuova pratica
      $q.all({
        nuovaPratica: self.promiseNuovaPratica(),
      })
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response.nuovaPratica)) {
              self.errorFromService = true;
              self.ricercaClienteSrvc.preserveSearch = true;
              self.$window.history.back();
              return;
            }

            var param = self.$stateParams;
            param.idPratica = response.nuovaPratica.data.result.idPratica;
            param.ndg = response.nuovaPratica.data.result.intestatario.ndg;

            self.$state.go('creas-dettaglio-pratica', param);
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.nuovaPratica);
            self.errorFromService = true;
          }
        )
        .finally(function () {
          self.spinner.pratica = false;
        });
    };

    self.spinner.pratica = true;
    this.userSrvc.abilitazioniPronte.then(function (result) {
      // Verifico se Credito assicurativo è abilitato
      // in caso contrario rimando alla home
      self.spinner.pratica = false;
      for (var i = 0; i < self.userSrvc.abilitazioni.length; i++) {
        if (
          self.userSrvc.abilitazioni[i].codice ===
          'CreditoAssicurativoPMIAbilitato'
        ) {
          // Se ho ricevuto un id pratica dai parametri, eseguo il
          // recupero dei dati altrimenti verifico di aver
          // ricevuto i dati del cliente. Successivamente, elaboro
          // le tab
          if (self.$stateParams.idPratica) {
            self.inizializzaPraticaEsistente(self.$stateParams.idPratica);
          } else {
            self.inizializzaNuovaPratica();
          }
          return;
        }
      }

      self.$state.go('schedaCliente');
    });
  };

  CreasDettaglioPraticaCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    '$uibModal',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'UserSrvc',
    'CreasDettaglioPraticaSrvc',
    'CreasModelFctr',
    'CreasRicercaClienteSrvc',
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasDettaglioPratica.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasDettaglioPraticaComponent = {
    controller: CreasDettaglioPraticaCtrl,
    controllerAs: 'creasDettaglioPraticaCtrl',
    templateUrl: TemplateUrl,
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasDettaglioPratica', CreasDettaglioPraticaComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasDettaglioPratica.cmpt.js
// module id = 16
// module chunks = 0 1